// Shared constants for the sales playbook surface.
//
// The playbook grouping field was renamed backend-side from `industry` to
// `playbookName` (salesguru-backend PR 34); these constants are the single
// source of truth for the new field key and its user-facing label so no
// literal is sprinkled across components.

/** API/state field key for the playbook grouping (matches the backend contract). */
export const PLAYBOOK_NAME_FIELD = 'playbookName';

/** User-facing label for the playbook grouping field. */
export const PLAYBOOK_NAME_LABEL = 'Playbook Name';

/** Dropdown placeholder shown when no playbook is selected. */
export const PLAYBOOK_SELECT_PLACEHOLDER = `Select ${PLAYBOOK_NAME_LABEL}...`;

/** Empty-state copy shown until a playbook is selected. */
export const PLAYBOOK_EMPTY_STATE_TEXT = 'Select a playbook name to view sales playbook';

/** Neutral placeholder rendered when a playbook name/display value is absent. */
export const PLAYBOOK_VALUE_PLACEHOLDER = '—';

/** Bucket label for playbooks whose playbookName is missing (defensive render). */
export const PLAYBOOK_UNNAMED_LABEL = 'Unnamed';

// Legacy label copy, rendered only while the playbookNameLabelEnabled flag is
// OFF on the live-call surface (the data key is always playbookName).
// TODO(naren): delete once the flag is removed after stabilization.
export const LEGACY_PLAYBOOK_NAME_LABEL = 'Industry';
export const LEGACY_PLAYBOOK_SELECT_PLACEHOLDER = 'Select Industry...';
export const LEGACY_PLAYBOOK_EMPTY_STATE_TEXT = 'Select an industry to view sales playbook';

/** How long a live (AI) check stays green before it settles to struck through. */
export const LIVE_CHECK_HIGHLIGHT_MS = 3000;

/**
 * How long a live (AI) note shows in the list: it slides in on green that fades
 * by 3.5 s, then folds away (`.note-arrive`). After that the item's tooltip shows it.
 */
export const LIVE_NOTE_SHOWN_MS = 5000;
